import { Icon } from '@studio/design-system/icon';
import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import type { HtmlAttributes } from '@studio/design-system/props';
import { StatusEncoderOperationMode } from '@tryiris-ai/common.protojs/agent/v1/agent';

/** `<Indicator>` properties. */
export type Props = HtmlAttributes & {
  mode: StatusEncoderOperationMode;
};

/** `<Indicator>` component. */
export const Indicator = ({ className, mode, ...props }: Props): ReactElement | null => {
  let icon: string | undefined;
  let message: string | undefined;

  if (mode === StatusEncoderOperationMode.OPERATION_MODE_DEGRADED) {
    icon = 'alert-triangle';
    message = 'Device is experiencing high load. You may experience degraded performance.';
  } else if (
    mode === StatusEncoderOperationMode.OPERATION_MODE_MINIMAL_SAFE ||
    mode === StatusEncoderOperationMode.OPERATION_MODE_RECOVERY
  ) {
    icon = 'alert-triangle text-error';
    message = 'Critical resource usage detected.';
  } else {
    return null;
  }

  return (
    <div
      className={twMerge('rounded bg-base-300/25 p-6 text-base text-warning', className)}
      {...props}
    >
      <Icon icon={icon} title={message} />
    </div>
  );
};
